// extracted by mini-css-extract-plugin
module.exports = {"packList":"ChoosePack_packList__jqcWU","checkMb":"ChoosePack_checkMb__CwNNg","inputMb":"ChoosePack_inputMb__ap9jI"};